export const API_URL = 'https://songbook-4fa14-api.herokuapp.com';
// export const API_URL = 'http://localhost:8080';
export const GOOGLE_RECAPTCHA_KEY_SITE = '6LckULwZAAAAAPbmbni2y5flTsi5crJBny8AwYXN';

export const LAST_PLAYED_SONGS_LIST_SIZE = 5;
